<div class="card kpi-blue">
    <div class="card-body kpi-card">
        <h5 class="card-title">Total du projet</h5>
        <p class="card-value">
            <ng-container *ngIf="preview">- €</ng-container>
            <ng-container *ngIf="!preview">
                {{ favorite.total_price | number: '1.0-0' }} <span class="fs-7"> €</span>
            </ng-container>
        </p>
    </div>
</div>
